import React, { useState } from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import { AuthCard, Field, ErrorBox, GoogleButton, Divider, formatApiError } from '../components/auth/AuthCard';
import { LOGIN } from '../constants/testIds/auth';

export default function LoginPage() {
  const { loginWithPassword, loginWithGoogle, user } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') && params.get('next') !== '/login' ? params.get('next') : '/';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={next} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      await loginWithPassword(email.trim(), password);
      navigate(next, { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthCard title="ଲଗଇନ କରନ୍ତୁ" subtitle="Quiz score, bookmark ଓ progress save କରିବାକୁ ଲଗଇନ କରନ୍ତୁ">
      <GoogleButton onClick={() => loginWithGoogle(next)} />
      <Divider />
      <form onSubmit={submit} className="space-y-3" data-testid="login-form">
        <Field label="ଇମେଲ୍ / Email" type="email" required autoComplete="email" testId={LOGIN.emailInput}
          value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" />
        <Field label="ପାସୱାର୍ଡ / Password" type="password" required autoComplete="current-password" testId={LOGIN.passwordInput}
          value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" />
        <ErrorBox message={error} testId="login-error" />
        <Button type="submit" disabled={busy} data-testid={LOGIN.submitButton}
          className="w-full h-12 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold gap-2">
          <LogIn size={16} /> {busy ? 'ଅପେକ୍ଷା କରନ୍ତୁ…' : 'ଲଗଇନ'}
        </Button>
      </form>
      <div className="flex items-center justify-between mt-4 text-xs">
        <Link to="/forgot-password" className="text-emerald-700 font-bold" data-testid={LOGIN.forgotPasswordLink}>ପାସୱାର୍ଡ ଭୁଲିଗଲେ?</Link>
        <Link to={`/register?next=${encodeURIComponent(next)}`} className="text-gray-700 font-bold" data-testid={LOGIN.registerLink}>ନୂଆ ଖାତା ଖୋଲନ୍ତୁ</Link>
      </div>
    </AuthCard>
  );
}
